import OnboardingPortal from './components/OnboardingPortal';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import { connect } from 'react-redux';

import './assets/OnboardingPortal.css'

function mapStateToProps(state,props){
  return {
    environment:state.version.environment,
    frontEndVersion:state.version.frontend,
    backEndVersion:state.version.backend    
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({},dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(OnboardingPortal));



// WEBPACK FOOTER //
// ./src/routes/OnboardingPortal/index.js